export default __webpack_public_path__ + "static/pdp--story-1ef434bc6e85b912824e59382d7fe74d.jpg";